module.exports = "/_next/static/files/69ad2e376e97c39089efaf2122daf5fe.jpg";